import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LearningObjectiveOrder } from './../model/model';
import {
    AddLearningObjectiveOrderCommand, UpdateLearningObjectiveOrderCommand,
    UpdateLearningObjectiveOrderTitleCommand, DeleteLearningObjectiveOrderCommand
} from '../model/interfaces';
import { pipe, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Avoid name not found warnings
@Injectable()
export class LearningObjectiveOrderService {
    public queryEndPoint = 'query-api/LearningObjectiveOrder';
    public groupQueryEndPoint = 'query-api/Group';
    public commandEndPoint = 'command-api/LearningObjectiveOrder';
    constructor(private http: HttpClient) { }

    get = (id: string) => this.http.get<LearningObjectiveOrder>(`${this.queryEndPoint}/${id}`)
        .pipe(
            map(list => list),
            catchError(_ => of(<LearningObjectiveOrder>null)) // if not found, return null
        )

    delete = (id: string) => this.http.post(`${this.commandEndPoint}/DeleteLearningObjectiveOrder`,
        <DeleteLearningObjectiveOrderCommand>{ id: id })

    getByGroup = (groupId: string) => this.http
        .get<LearningObjectiveOrder[]>(`${this.groupQueryEndPoint}/${groupId}/LearningObjectiveOrders`)

    add = (title: string, learningObjectives: string[]) => {
        const command = <AddLearningObjectiveOrderCommand>{
            title: title,
            learningObjectives: learningObjectives
        };
        return this.http.post<LearningObjectiveOrder>(`${this.commandEndPoint}/AddLearningObjectiveOrder`, command);
    }


    update = (id: string, learningObjectives: string[]) => this.http.post(`${this.commandEndPoint}/UpdateLearningObjectiveOrder`,
        <UpdateLearningObjectiveOrderCommand>{
            id: id,
            learningObjectives: learningObjectives ? learningObjectives : []
        }, { responseType: 'text' })

    updateTitle = (id: string, title: string) =>
        this.http.post(`${this.commandEndPoint}/UpdateLearningObjectiveOrderTitle`,
            <UpdateLearningObjectiveOrderTitleCommand>{
                id: id,
                title: title
            }, { responseType: 'text' })
}
